import {
    accept,
    addGreenCard,
    adjustNonConDueDate,
    changeProcedure,
    editNonConSeverityAndType,
    summariseNonCon
} from "./actions.js";
import {
    correctiveAction,
    extension,
    issue,
    preventativeAction,
    rootCause,
    summary,
    supportingEvidence
} from "./internalAttachables.js";
import { hodAcceptedIssue, hodIssueNotYetAccepted, sectionAcceptance } from "../nonConFieldValues.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import _jobCardsAttachable from "../../Database/JobCards/attachable.js";
import { nonConformityReport } from "./reports.js";

const jobCardsAttachable = {
    label: _jobCardsAttachable.label,
    key: _jobCardsAttachable.key,
    location: _jobCardsAttachable.location,
    headers: _jobCardsAttachable.headers,
    rowActions: _jobCardsAttachable.rowActions
};

jobCardsAttachable.actions = [{
    "label": "Add Job Card",
    "action": async ({ store, db, pageItem, data }) => {
        await addGreenCard({
            store,
            db,
            pageItem: {
                "ID": pageItem.ParentID,
                "Number": pageItem.Number
            },
            data: pageItem,
            'NonConID': pageItem.ID
        });
    },
    show({ pageItem }) {
        return [!pageItem.JobCards, "A green card has already been added."]
    }
}];

const NOT_YET_REVIEWED = "Not Yet Reviewed";

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Report",
    "key": "Report",
    "link": "Audits/Reports/:ReportID"
}, {
    "label": "Procedure",
    "key": "Procedure"
}, {
    "label": "Type and Severity",
    compute({ item }) {
        return `${item.Type} - ${item.Severity}`
    }
}, {
    "label": "Date Due",
    "key": "Date.Due",
    "type": "date"
}, {
    "label": "HoD Accepted Issue",
    compute({ item }) {
        return hodAcceptedIssue(item, NOT_YET_REVIEWED)
    }
}, {
    "label": "Root Cause",
    compute({ item }) {
        return sectionAcceptance(item, "RootCause", NOT_YET_REVIEWED)
    },
    "grow": true
}, {
    "label": "Corrective Action",
    compute({ item }) {
        return sectionAcceptance(item, "CorrectiveAction", NOT_YET_REVIEWED)
    },
    "grow": true
}, {
    "label": "Preventative Action",
    compute({ item }) {
        return sectionAcceptance(item, "PreventativeAction", NOT_YET_REVIEWED)
    },
    "grow": true
}];

const menuActions = [{
    "label": "Change Non Conformity Severity and Type",
    "action": editNonConSeverityAndType,
    // show({ pageItem }) {
    //     return [!pageItem.Issue.HOD, "HoD has already accepted this issue."]
    // }
}, {
    "label": "Adjust Non Conformity Due Date",
    "action": adjustNonConDueDate,
    // show({ pageItem }) {
    //     return [!pageItem.Issue.HOD, "HoD has already accepted this issue."]
    // }
}, {
    "label": "Change Procedure",
    "action": changeProcedure
},{
    "label": "HoD Accept Issue",
    "action": accept("HOD", "Issue"),
    show({ pageItem }) {
        return [hodIssueNotYetAccepted(pageItem), "HoD has already accepted this issue."]
    }
}, {
    "label": "Download Report",
    "action": nonConformityReport
}, {
    "label": "Summarise Non Conformity",
    "action": summariseNonCon
}];

export default [{
    "path": "/Audits/NonConformities",
    "component": { ...ItemListView },
    "name": "Non Conformities",
    "meta": {
        "app": "Audits",
        "storeData": ["Audits/Procedures", "Audits/CoreProcedures", "Audits/Cycles"],

        "name": "Non Conformities",
        "sideNav": true,
        "sideNavSection": "Reports",
        "appSwitcher": false,
        "icon": "check-circle",
        "tableSettings": "NonConformities",
        "dataPath": "Audits/NonConformities",
        "selectionRoute": "Audits/NonConformities/{ID}"
    }
}, {
    "path": "/Audits/NonConformities/:id",
    "component": ItemView,
    "name": "Non Conformity",
    "meta": {
        "app": "Audits",
        "storeData": ["Audits/Procedures", "Audits/CoreProcedures", "Audits/Cycles"],
        "ParentType": "NonConformities",
        "name": "Non Conformity",
        title(item) {
            return `Non Conformity: ${item?.Number}`
        },
        "formMetadata": {
            "ParentType": "NonConformities",
        },
        "attachedItems": {
            "Issue": {
                "attachables": [issue, supportingEvidence]
            },
            "Actions Taken": {
                "attachables": [rootCause, correctiveAction, preventativeAction]
            },
            "Extension": {
                "attachables": [extension]
            },
            "Projects": {
                "attachables": [jobCardsAttachable]
            },
            "AI Tools": {
                "attachables": [summary]
            }
        },
        dataFields,
        menuActions
    }
}];
